
class Router {
    constructor() {
        this.appsContainer = document.querySelector('.micro-app-container');
        this.appPrefix = ''; //the prev sub domain (host/tenent) now in path before /app/
    }

    setAppsData = data => this.appsData = data;
    getAppsData = () => this.appsData;
    
    setAppPrefix = () => {
        try {
            const splittedPath = window.location.pathname.split('/');
            const appIndex = splittedPath.indexOf('app');
            this.appPrefix = appIndex > -1 && splittedPath[appIndex - 1] ? `${splittedPath.filter(n => n).slice(0, appIndex-1).join('/')}` : '';
            this.staticURL = this.appPrefix ? `${location.origin}/${this.appPrefix}/static/` : `${location.origin}/static/`;
        } catch (error) {
           console.error(error); 
        }
    }

    getPathByAppId = (appId) => {
        if (!appId) {return  '';}
        return `${this.appPrefix ? `${this.appPrefix}/` : ''}static/${appId}`;
    }

    getMainPath = path => {
        try {
            if (path === '/' || !path.includes('/app') || path.endsWith('/app') || path.endsWith('/app/')) {
                return '/';
            }
            let splittedPath = path.split('/');
            const appIndex = splittedPath.indexOf('app');
            return splittedPath[appIndex + 1] ? `${this.appPrefix ? `${this.appPrefix}/` : ''}app/${splittedPath[appIndex + 1]}` : '/';
        } catch (error) {
            return '';
        }
    }

    getAppPath = appId => {
        try {
            const fullPath = location.href.replace(location.origin, ''); //includes hash and query
            const searchSplit = fullPath.split('?');
            const splitted = searchSplit[0].split('/');
            const appIdIndex = splitted.indexOf(appId);
            if (appIdIndex !== -1 && appIdIndex + 1 < splitted.length) {
                return `/${splitted.slice(appIdIndex + 1).filter(p => p && p !== location.search).join('/')}${location.search}`; // remove empty strings from array
            }
            return location.search;   
        } catch (error) {
            console.error(error);
            return location.search;
        }
    }

    onNavigate = (appId, menuItemId) => {
        const pathName = `${this.appPrefix}/app/${appId}`;
        window.history.pushState({ appId, menuItemId, appPath: '' }, appId, `${window.location.origin}/${pathName}`);
    }
 }

export const router = new Router();